<template>
    <div class="article">
        <new-1 v-if="page == 1"></new-1>
        <new-2 v-else-if="page == 2"></new-2>
        <new-3 v-else-if="page == 3"></new-3>
        <new-4 v-else-if="page == 4"></new-4>
        <new-5 v-else-if="page == 5"></new-5>
        <new-6 v-else-if="page == 6"></new-6>
        <new-7 v-else-if="page == 7"></new-7>
        <new-8 v-else-if="page == 8"></new-8>
        <new-9 v-else-if="page == 9"></new-9>
        <new-10 v-else-if="page == 10"></new-10>
        <new-11 v-else-if="page == 11"></new-11>
    </div>
</template>
<script>
    import new1 from './news1.vue'
    import new2 from './news2.vue'
    import new3 from './news3.vue'
    import new4 from './news4.vue'
    import new5 from './news5.vue'
    import new6 from './news6.vue'
    import new7 from './news7.vue'
    import new8 from './news8.vue'
    import new9 from './news9.vue'
    import new10 from './news10.vue'
    import new11 from './news11.vue'
    export default {
        components: {
            new1,
            new2,
            new3,
            new4,
            new5,
            new6,
            new7,
            new8,
            new9,
            new10,
            new11
        },
        data() {
            return {
                page: null
            }
        },
        created() {
            this.page = this.$route.query.page
        }
    }
</script>
<style lang="scss" scoped>
    .article {
        width: 750px;
        margin: 0 auto;
    }
    @media screen and (max-width: 750px) {
        .article {
            width: 100%;
            margin: 0 auto;
        }
    }
</style>